// RMJ Rice Mill — data catalog
export const SALES_PERSONS = [
  "Subashini",
  "Vetrivel",
  "Udayabanu",
  "Nagarajan",
  "Murugesan",
  "Thangapandi",
  "JTP",
  "Vel Murugan",
  "Thiruvenkatasamy",
  "Kalirajan",
  "Jeyapandi",
  "Arunachalam",
];

export const PRICELISTS = [
  "Wholesale Pricelist",
  "Retail Pricelist",
  "Bulk Pricelist",
  "Bangalore Pricelist",
  "Customer Specific Pricelist",
];

export const SEGMENTS = [
  "Direct Exports",
  "Merchant Exports",
  "Private Labeling",
  "Idli Batter Company",
  "Modern Trade",
  "GT WS & Supermarkets",
  "Rice Mandi WS",
  "HoReCa",
  "Government supply",
  "Quick Commerce - B2B",
  "Quick Commerce - B2C",
  "Ecommerce & RS - B2C",
  "Broker sales",
];

export const CURRENCIES = [
  { code: "INR", label: "INR · Indian Rupee", symbol: "₹" },
  { code: "USD", label: "USD · US Dollar", symbol: "$" },
  { code: "EUR", label: "EUR · Euro", symbol: "€" },
  { code: "GBP", label: "GBP · British Pound", symbol: "£" },
  { code: "AED", label: "AED · UAE Dirham", symbol: "د.إ" },
  { code: "SGD", label: "SGD · Singapore Dollar", symbol: "S$" },
  { code: "MYR", label: "MYR · Malaysian Ringgit", symbol: "RM" },
  { code: "CAD", label: "CAD · Canadian Dollar", symbol: "C$" },
  { code: "AUD", label: "AUD · Australian Dollar", symbol: "A$" },
];

// Master SKU sizes
export const SKU_1 = { key: "1kg", label: "1 Kg", weight: 1 };
export const SKU_5 = { key: "5kg", label: "5 Kg", weight: 5 };
export const SKU_10 = { key: "10kg", label: "10 Kg", weight: 10 };
export const SKU_26 = { key: "26kg", label: "26 Kg", weight: 26 };
// Loose: customer-defined weight. Salesperson types qty (Kg) directly,
// rate is always manual (never auto-filled from a pricelist).
export const SKU_LOOSE = { key: "loose", label: "Loose", weight: 0 };

const DEFAULT_SKUS = [SKU_5, SKU_10, SKU_26, SKU_LOOSE];

// Each variety has its own SKU list per requirements
export const VARIETIES = [
  { name: "Nei Kitchadi Ponni", skus: DEFAULT_SKUS },
  { name: "Rajabhogam Ponni", skus: [SKU_1, SKU_5, SKU_10, SKU_26, SKU_LOOSE] },
  { name: "Akshaya Ponni", skus: DEFAULT_SKUS },
  { name: "Manachanallur Ponni", skus: DEFAULT_SKUS },
  { name: "VIP Rajabhogam Ponni", skus: DEFAULT_SKUS },
  { name: "Tanjore Ponni", skus: DEFAULT_SKUS },
  { name: "ASD16 Idli", skus: DEFAULT_SKUS },
  { name: "Yellow Idli", skus: [SKU_1, SKU_5, SKU_10, SKU_26, SKU_LOOSE] },
  { name: "Orange Idli", skus: [SKU_26, SKU_LOOSE] },
  { name: "Seeraga Samba Pure", skus: [SKU_1, SKU_5, SKU_26, SKU_LOOSE] },
  { name: "Seeraga Samba 7030", skus: [SKU_1, SKU_5, SKU_26, SKU_LOOSE] },
  { name: "Raw Sona Masoori", skus: [SKU_5, SKU_10, SKU_26, SKU_LOOSE] },
  { name: "Steam Sona Masoori", skus: [SKU_5, SKU_26, SKU_LOOSE] },
  { name: "Raw Kolam (Ramajeyam)", skus: [SKU_5, SKU_26, SKU_LOOSE] },
  { name: "Raw Kolam (Sangu Chakkaram)", skus: [SKU_5, SKU_26, SKU_LOOSE] },
  { name: "Raw Nei Kitchadi", skus: [SKU_5, SKU_26, SKU_LOOSE] },
  { name: "Pongal / White Raw Rice", skus: [SKU_26, SKU_LOOSE] },
  { name: "Idli Broken", skus: [SKU_26, SKU_LOOSE] },
  { name: "Ponni Broken", skus: [SKU_26, SKU_LOOSE] },
];

// Pricelist rate sheets (₹ / Kg per variety per SKU). Source: RMJ price-list
// PDFs dated 10.08.2026 (Wholesale, Retail, Bulk, Bangalore). Used to
// auto-fill the Rate column on the Order Form. Customer Specific Pricelist
// uses MANUAL rate entry.
export const PRICELIST_RATES = {
  "Wholesale Pricelist": {
    "Nei Kitchadi Ponni":    { "5kg": 74, "10kg": 73, "26kg": 70 },
    "Akshaya Ponni":         { "5kg": 72, "10kg": 71, "26kg": 68 },
    "Manachanallur Ponni":   { "5kg": 64, "10kg": 63, "26kg": 60 },
    "Tanjore Ponni":         { "5kg": 61, "10kg": 60, "26kg": 57 },
    "ASD16 Idli":            { "1kg": 50, "5kg": 49, "10kg": 48, "26kg": 45 },
    "Rajabhogam Ponni":      { "1kg": 74, "5kg": 73, "10kg": 72, "26kg": 69 },
    "Yellow Idli":           { "1kg": 49, "5kg": 48, "10kg": 47, "26kg": 44 },
    "VIP Rajabhogam Ponni":  { "5kg": 69, "10kg": 68, "26kg": 65 },
    "Seeraga Samba Pure":    { "1kg": 185, "5kg": 184, "26kg": 180 },
    "Seeraga Samba 7030":    { "5kg": 164, "26kg": 160 },
    "Raw Kolam (Ramajeyam)":       { "5kg": 84, "26kg": 80 },
    "Raw Kolam (Sangu Chakkaram)": { "5kg": 77, "26kg": 73 },
    "Pongal / White Raw Rice": { "26kg": 39 },
    "Orange Idli":           { "26kg": 42 },
    "Idli Broken":           { "26kg": 34 },
    "Ponni Broken":          { "26kg": 34 },
    // Raw Sona Masoori & Steam Sona Masoori — NOT AVAILABLE (10.08.2026).
  },
  "Retail Pricelist": {
    "Nei Kitchadi Ponni":    { "5kg": 75, "10kg": 74, "26kg": 71 },
    "Akshaya Ponni":         { "5kg": 73, "10kg": 72, "26kg": 69 },
    "Manachanallur Ponni":   { "5kg": 65, "10kg": 64, "26kg": 61 },
    "Tanjore Ponni":         { "5kg": 62, "10kg": 61, "26kg": 58 },
    "ASD16 Idli":            { "1kg": 51, "5kg": 50, "10kg": 49, "26kg": 46 },
    "Rajabhogam Ponni":      { "1kg": 75, "5kg": 74, "10kg": 73, "26kg": 70 },
    "Yellow Idli":           { "1kg": 50, "5kg": 49, "10kg": 48, "26kg": 45 },
    "VIP Rajabhogam Ponni":  { "5kg": 70, "10kg": 69, "26kg": 66 },
    "Seeraga Samba Pure":    { "1kg": 186, "5kg": 185, "26kg": 181 },
    "Seeraga Samba 7030":    { "5kg": 165, "26kg": 161 },
    "Raw Kolam (Ramajeyam)":       { "5kg": 85, "26kg": 81 },
    "Raw Kolam (Sangu Chakkaram)": { "5kg": 78, "26kg": 74 },
    "Pongal / White Raw Rice": { "26kg": 40 },
    "Orange Idli":           { "26kg": 43 },
    "Idli Broken":           { "26kg": 35 },
    "Ponni Broken":          { "26kg": 35 },
    // Raw Sona Masoori & Steam Sona Masoori — NOT AVAILABLE (10.08.2026).
  },
  "Bulk Pricelist": {
    "Nei Kitchadi Ponni":    { "5kg": 72, "10kg": 71, "26kg": 68 },
    "Akshaya Ponni":         { "5kg": 70, "10kg": 69, "26kg": 66 },
    "Manachanallur Ponni":   { "5kg": 62, "10kg": 61, "26kg": 58 },
    "Tanjore Ponni":         { "5kg": 59, "10kg": 58, "26kg": 55 },
    "ASD16 Idli":            { "1kg": 48, "5kg": 47, "10kg": 46, "26kg": 43 },
    "Rajabhogam Ponni":      { "1kg": 72, "5kg": 71, "10kg": 70, "26kg": 67 },
    "Yellow Idli":           { "1kg": 47, "5kg": 46, "10kg": 45, "26kg": 42 },
    "VIP Rajabhogam Ponni":  { "5kg": 67, "10kg": 66, "26kg": 63 },
    "Seeraga Samba Pure":    { "1kg": 183, "5kg": 182, "26kg": 178 },
    "Seeraga Samba 7030":    { "5kg": 162, "26kg": 158 },
    "Raw Kolam (Ramajeyam)":       { "5kg": 82, "26kg": 78 },
    "Raw Kolam (Sangu Chakkaram)": { "5kg": 75, "26kg": 71 },
    "Pongal / White Raw Rice": { "26kg": 37 },
    "Orange Idli":           { "26kg": 40 },
    "Idli Broken":           { "26kg": 34 },
    "Ponni Broken":          { "26kg": 34 },
    // Raw Sona Masoori & Steam Sona Masoori — NOT AVAILABLE (10.08.2026).
  },
  "Bangalore Pricelist": {
    // Bangalore PDF dated 10.08.2026. Only items currently distributed in the
    // Bangalore territory. Varieties absent here leave the Rate column blank.
    "Akshaya Ponni":         { "5kg": 74, "10kg": 73, "26kg": 70 },
    "VIP Rajabhogam Ponni":  { "5kg": 71, "10kg": 70, "26kg": 67 },
    "Yellow Idli":           { "5kg": 47, "10kg": 46, "26kg": 43 },
    "Orange Idli":           { "26kg": 42 },
    "Raw Kolam (Ramajeyam)":       { "5kg": 86, "26kg": 82 },
    "Raw Kolam (Sangu Chakkaram)": { "5kg": 79, "26kg": 75 },
  },
};

// Pricelists that use manual rate entry (no auto-fill).
export const MANUAL_PRICELISTS = new Set([
  "Customer Specific Pricelist",
]);
